

const initStat = {
    languageWeb :'العربية',

}

const LanguageReducer = (state = initStat , action) => {
    switch (action.type) {
        case 'LANGUAGE_WEB': return { languageWeb : action.payload}


        default: return state;
    }
}

export default LanguageReducer;
